import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageNames} from '../../shared/page-names.enum';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {DtvCatalogUtils} from '../../utils/dtv-catalog/dtv-catalog.utils';
import {NavigationService} from '../../services/navigation/navigation.service';
import {BaseActions} from '../../shared/base-actions';
import {Order} from '../../model/order';
import {ImageUtils} from '../../shared/utils/image/image-utils';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-product-detail-info',
  templateUrl: './product-detail-info.component.html',
  styleUrls: ['./product-detail-info.component.less']
})
export class ProductDetailInfoComponent extends BaseActions implements OnInit {
  @Input()
  titleKey: string;
  @Input()
  descriptionKey: string;
  @Input()
  omapiId: string;
  @Input()
  play: boolean;
  @Output()
  emitOrderProduct = new EventEmitter<Object>();
  @Input()
  superiorSubscribedPack: TvShopEntertainmentPack;

  pack: TvShopEntertainmentPack;

  componentName = PageNames.DETAIL_PAGE_INFO;

  @Input()
  columns2 = true;

  constructor(private stateService: TvShopStateService,
              private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    const packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    this.pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(packs, this.omapiId);
  }

  public get backgroundImageUrl(): string {
    return ImageUtils.getBackgroundImageUrl(this.omapiId, 'info');
  }

  public get bannerImageUrl(): string {
    return ImageUtils.getBannerImageUrl(this.omapiId, 'info');
  }

  public get logoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
  }

  onBack(): void {
    this.navigationService.resetPage();
  }

  public onEmitOrderProduct(event: Order): void {
    this.emitOrderProduct.emit(event);
  }
}
